<template>
    <div>
        <v-card color="white" elevation="0" class="d-flex align-content-end" width="100%">
            <v-card-text style="color: black;">
                <v-row justify="center" align="center">
                    <v-col cols="11">
                        <v-row>
                            <v-col cols="12" md="12" v-if="item.status == 'stopped'">
                                <v-alert outlined type="warning" dense prominent>
                                    This Posting was stopped at {{ translateTimestamp(item.history[0]["postingStopCreatedTimestamp"]) }} by {{ item.history[0]["postingStopCreatedByCommonName"] }}
                                </v-alert>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-img src="../../../assets/background/Kings_international_3308.jpg" width="100%" height="200px" contain></v-img>
                            </v-col>
                            <v-col cols="12" md="6" class="d-flex align-center">
                                <span>
                                    <span class="text-h4">PART-TIME FACULTY APPOINTMENTS</span><br />
                                    <b>These work assignments are posted and filled in accordance with the Collective Agreement between King's University College and CUPE 5265.</b>
                                </span>
                            </v-col>
                            <v-col cols="12" md="4" class="d-flex align-start">
                                <v-container style="border: 1px solid #145DA0">
                                    <v-row align="center" justify="start">
                                        <v-col cols="12" md="5">Approval Status: </v-col>
                                        <v-col cols="12" md="7" style="text-align: left;">
                                            <v-row style="margin: auto;">
                                                <v-checkbox
                                                    v-model="approved1"
                                                    disabled
                                                    :true-value="1"
                                                    hide-details
                                                ></v-checkbox>
                                                <v-checkbox
                                                    v-model="approved2"
                                                    disabled
                                                    :true-value="1"
                                                    hide-details
                                                ></v-checkbox>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="4">Approved by: </v-col>
                                        <v-col cols="12" md="8">
                                            <span v-if="(approved1 == 0 && approved2 == 1) || approved1 == 1">{{ approved1by }} / </span>
                                            <span v-if="approved2 == 1">{{ approved2by }}</span>
                                        </v-col>
                                        <v-col cols="12" md="4">Approved on: </v-col>
                                        <v-col cols="12" md="8">
                                            <span v-if="approved1 == 1">{{ approved1time }} / </span>
                                            <span v-if="approved2 == 1">{{ approved2time }}</span>
                                        </v-col>
                                        <v-col cols="12" md="4" v-if="item.status == 'stopped'" style="color: #DF362D;">Stop Reason: </v-col>
                                        <v-col cols="12" md="8" v-if="item.status == 'stopped'">
                                            {{ item.history[0]["stopreason"] }}
                                        </v-col>
                                        <v-col cols="12" md="4" v-if="item.hasOwnProperty('liveedit') && liveeditpermission">Live Edit Reason: </v-col>
                                        <v-col cols="12" md="8" v-if="item.hasOwnProperty('liveedit') && liveeditpermission">
                                            {{ item.liveedit }}
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-col>
                            <v-col cols="12" md="12" class="text-h5">{{ resolveGeneralTerm }} Term</v-col>
                            <v-col cols="12" md="12" v-if="resolveType">
                                The following courses are being posted as a multi-section/course position as per Article 12.05 of the Collective Agreement. 
                                The successful candidate must accept the position in its entirety.
                            </v-col>
                            <v-col cols="12" md="12">
                                <span class="text-h6">
                                    Academic Unit: {{ item.department }}<br />
                                    {{ item["subject-resolved"] }} - {{ item.type }} Posting
                                </span>
                            </v-col>
                        </v-row>
                        <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th rowspan="2">Term</th>
                                        <th rowspan="2">Section</th>
                                        <th rowspan="2">Class Format</th>
                                        <th rowspan="2">Catalog</th>
                                        <th rowspan="2">Name</th>
                                        <th rowspan="2">Component</th>
                                        <th rowspan="2">Approx. Size</th>
                                        <th colspan="5" style="text-align: center;">Days</th>
                                        <th rowspan="2">Start Date</th>
                                        <th rowspan="2">End Date</th>
                                        <th rowspan="2">Time</th>
                                    </tr>
                                    <tr>
                                        <th>Mon</th>
                                        <th>Tue</th>
                                        <th>Wed</th>
                                        <th>Thu</th>
                                        <th>Fri</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="course in item.courses" :key="course.classnbr">
                                        <td>{{ resolveTerm(course.sessioncode) }}</td>
                                        <td>{{ course.classsection }}</td>
                                        <td>{{ course.classformat }}</td>
                                        <td>{{ course.catalognbr }}</td>
                                        <td>{{ course.descr }}</td>
                                        <td>{{ course.ssrcomponent }}</td>
                                        <td>{{ course.enrlcap }}</td>
                                        <td><v-checkbox v-model="course.mon" disabled true-value="Mon"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.tues" disabled true-value="Tue"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.wed" disabled true-value="Wed"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.thurs" disabled true-value="Thu"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.fri" disabled true-value="Fri"></v-checkbox></td>
                                        <td>{{ course.instructionstart }}</td>
                                        <td>{{ course.instructionend }}</td>
                                        <td>{{ course.starttime }}-{{ course.endtime }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row justify="center" align="center">
                    <v-col cols="11">
                        <v-card elevation="0">
                            <v-simple-table style="width: 90%;">
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <td style="width: 20%;">Application Deadline</td>
                                            <td>{{ item.endDate }}</td>
                                        </tr>
                                        <tr v-if="resolveType">
                                            <td style="width: 20%;">Salary</td>
                                            <td>${{ item.salary }}</td>
                                        </tr>
                                        <tr>
                                            <td style="width: 20%;">Notes</td>
                                            <td style="white-space: pre-line;">{{ item.notes }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table><br />
                            <div>
                                This posting is for an existing vacancy.
                            </div><br />
                            <div>
                                <span class="text-h6">Qualifications</span><br/>
                                <p style="white-space: pre-line;">
                                    {{ item.qualifications.split("Academic Calendar")[0] }}<a href="https://www.westerncalendar.uwo.ca/Courses.cfm?SelectedCalendar=Live&ArchiveID=" target="_blank">Academic Calendar</a>{{ item.qualifications.split("Academic Calendar")[1] }}
                                </p>
                            </div><br />
                            <div>
                                <span class="text-h6">Responsibilities</span><br/>
                                <p>
                                    Your responsibilities include, but are not limited to course preparation/materials; 
                                    classroom/laboratory instruction; setting and marking all graded course components (tests, assignments, etc.); 
                                    meeting with students (office hours); classroom management, proctoring tests/examinations; 
                                    and the resolution of student appeals related to this work assignment (Article 12.04). 
                                    The carrying out of these responsibilities may need to take place preceding and/or following the period of instruction in matters such as but not limited to preparation of course syllabi, 
                                    marking and grading of exams and assignments, and fulfilling instructor obligations as set out by university policy related to student appeals and academic offences. 
                                </p>
                            </div><br />
                            <div v-if="!resolveType">
                                <span class="text-h6">Salary</span><br/>
                                <p>
                                    <v-simple-table style="width: 100%; border-collapse: collapse;">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Effective Date as of May 1</th>
                                                    <th>0.5 Course Load</th>
                                                    <th>1.0 Course Load</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="detail in item.salary" :key="detail.year">
                                                    <td>{{ detail.year }}</td>
                                                    <td>${{ detail.halfcourse }}</td>
                                                    <td>${{ detail.fullcourse }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </p><br />
                            </div>
                            <div>
                                <span class="text-h6">Applying at King's</span><br/>
                                <p>
                                    Consideration of applicants will include an assessment of qualifications, teaching competence, capability, skills and ability, 
                                    and prior relevant experience as well as seniority in cases where applicants are considered relatively equal. 
                                    Applicants should have fluent written and oral communication skills in English.<br /><br />
                                    Please note that Departments/Schools reserve the right to review and modify all course syllabi to ensure alignment with course and program learning outcomes, as necessary, 
                                    to ensure continuity across course sections and academic years, and in order to maintain the integrity of the academic program as a whole.<br /><br />
                                    Please be advised that course section caps may be exceeded from time to time. The College will endeavor to keep increases beyond the cap to a minimum so as not to compromise the pedagogical mode of delivery of the course.<br /><br />
                                    <b><i>All positions are subject to budgetary approval.</i></b><br /><br />
                                    
                                    <i>The College is committed to advancing the Catholic intellectual tradition and welcomes faculty, staff and students from all faiths and backgrounds. <br /><br />
                                    King's University College is committed to Employment Equity and welcomes applications from qualified individuals, including persons of all genders and sexual orientations, persons with disabilities, Indigenous persons, and racialized people.<br /><br />
                                    King's University College is committed to recognizing the dignity and independence of all and seeks to ensure that persons with disabilities have genuine, open and unhindered access to the College's employment opportunities. 
                                    If you require an accommodation during the recruitment process, please contact Human Resources at  <a href="mailto:HR@kings.uwo.ca">HR@kings.uwo.ca</a> or 519-433-3491 for assistance. <br /><br />
                                    All qualified candidates are encouraged to apply, however, Canadian citizens and permanent residents will be given priority.</i>
                                </p>
                            </div><br />
                        </v-card>
                    </v-col>
                </v-row>
                <v-row justify="end" align="end" v-if="item.status == 'active' && approvepermission">
                    <v-btn :disabled="(approved1 == 0 && approved2 == 1) || approved1 == 1" color="#3CACAE" @click="dialogApprove = true" style="float: right;">
                        <v-icon>mdi-check-decagram-outline</v-icon>&nbsp;Approve 1
                    </v-btn>&nbsp;
                    <v-btn :disabled="(approved1== 1 && approved2 == 1) || approved1 == 0" color="#04D4F0" @click="dialogApprove2 = true" style="float: right;">
                        <v-icon>mdi-check-decagram-outline</v-icon>&nbsp;Approve 2
                    </v-btn>
                </v-row>
                <v-row justify="end" align="end" v-if="item.status == 'active'">
                    <span style="float: right; color: green;" v-if="(approved1 == 1 && approved2 == 0) || (approved1 == 0 && approved2 == 1)" class="text-body-1">First Approval processed</span>&nbsp;&nbsp;
                    <span style="float: right; color: green;" v-if="approved1== 1 && approved2 == 1" class="text-body-1">Second Approval processed</span>&nbsp;&nbsp;
                </v-row>
            </v-card-text>
        </v-card>
        <v-dialog
            v-model="dialogApprove"
            persistent
            width="500px"
            v-if="approvepermission"
        >
            <v-card>
                <v-card-title class="text-h5" style="background-color: #C8F4F9;">
                    Approve Posting?
                </v-card-title><br />
                <v-card-text>
                    Please make sure you have reviewed all details on the posting. <b>Approve?</b>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="#FB6B90"
                        text
                        @click="dialogApprove = false"
                    >
                        Decline
                    </v-btn>
                    <v-btn
                        color="#3D550C"
                        text
                        @click="approvePosting(1)"
                        :loading="loadingApprove"
                    >
                        Approve
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogApprove2"
            persistent
            width="500px"
        >
            <v-card>
                <v-card-title class="text-h5" style="background-color: #C8F4F9;">
                    Approve Posting?
                </v-card-title><br />
                <v-card-text>
                    This is the <b>final approval</b> process for this posting. You will not be able to edit any details for this posting once approved. <b>Proceed?</b>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="#FB6B90"
                        text
                        @click="dialogApprove2 = false"
                    >
                        Decline
                    </v-btn>
                    <v-btn
                        color="#3D550C"
                        text
                        @click="approvePosting(2)"
                        :loading="loadingApprove"
                    >
                        Approve
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import auth from '@/js/auth';
export default {
    props: {
        item: {
            required: true
        }
    },
    data(){
        return {
            approvepermission: false,
            liveeditpermission: false,
            host: location.hostname.toString(),
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            dialogApprove: false,
            dialogApprove2: false,
            loadingApprove: false,
            approved1: 0,
            approved1time: "",
            approved1by: "",
            approved2: 0,
            approved2time: "",
            approved2by: ""
        }
    },
    computed: {
        resolveGeneralTerm(){
            const that = this;
            let term = that.item.strm.slice(-1);
            if(term == "9"){
                var year = that.item.strm[1]+that.item.strm[2];
                var year2 = (parseInt(year)+1).toString();
                var century = (parseInt(that.item.strm[0])-1).toString();
                return "FALL 2"+century+year+"/WINTER 2"+century+year2;
            }else if(term == "5"){
                var year = that.item.strm[1]+that.item.strm[2];
                var century = (parseInt(that.item.strm[0])-1).toString();
                return "SUMMER/INTERSESSION 2"+century+year;
            }
        },
        resolveType(){
            const that = this;
            if(/^CLUSTER/i.test(that.item.type)){
                return true
            }else {
                return false
            }
        },
    },
    methods: {
        closeDialog(){
            this.$emit("closeEvent");
        },
        getPermissions(){
            const that = this;
            let permission = auth.get_permissions();

            if(permission.hasOwnProperty("postingapprove")){
                if(permission.postingapprove == 1){
                    that.approvepermission = true;
                }else {
                    that.approvepermission = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.approvepermission = true;
            }else {
                that.approvepermission = false;
            }

            //live edit permission
            if(permission.hasOwnProperty("postingliveedit")){
                if(permission.postingliveedit == 1){
                    that.liveeditpermission = true;
                }else {
                    that.liveeditpermission = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.liveeditpermission = true;
            }else {
                that.liveeditpermission = false;
            }
        },
        resolveTerm(session){
            const that = this;
            let term = that.item.strm.slice(-1);
            if(term == "9"){
                var year = that.item.strm[1]+that.item.strm[2];
                var year2 = (parseInt(year)+1).toString();
                var century = (parseInt(that.item.strm[0])-1).toString();
                
                if(session == "0" || session == "5" || session == "Q5"){
                    return "FALL2"+century+year+"/WINTER2"+century+year2;
                }else if(session == "1" || session == "6"){
                    return "FALL 2"+century+year
                }else{
                    return "WINTER 2"+century+year2
                }
            }else if(term == "5"){
                return "SUMMER";
            }
        },
        initializeData(){
            const that = this;
            if(that.item.approve1 == 1){
                that.approved1 = 1;
                that.approved1time = that.translateTimestamp(that.item.approvals[0]["approvalCreatedTimestamp"]);
                that.approved1by = that.item.approvals[0]["approvalCreatedCommonName"];
            }

            if(that.item.approve2 == 1){
                that.approved2 = 1;
                that.approved2time = that.translateTimestamp(that.item.approvals[1]["approvalCreatedTimestamp"]);
                that.approved2by = that.item.approvals[1]["approvalCreatedCommonName"];
            }
        },
        translateTimestamp(timestamp){
            const that = this;

            var date = new Date(parseInt(timestamp));

            return date.toDateString();
        },
        approvePosting(step){
            const that = this;
            that.loadingApprove = true;

            let api= 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=postingapprove&data={"id":"'+that.item.id+'", "approvalState":1}';

            
            fetch(api)
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Approved successfully!", "green");
                    that.loadingApprove = false;
                    that.dialogApprove = false;
                    that.dialogApprove2 = false;

                    if(step == 1){
                        that.approved1 = 0;
                        that.approved2 = 1;
                    }else {
                        that.approved2 = 1;
                    }

                    that.closeDialog();
                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    that.loadingApprove = false;
                }
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
                that.loadingApprove = false;
            })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getPermissions();
        that.initializeData();
    }
}
</script>
<style scoped>
th{
    border: 1px solid #D3D3D3;
}
</style>